import React from 'react';
import { Route,Redirect} from 'react-router';
import ForgotPasswordPage from 'split-chunk-loader?lazy!../Auth/index';
import { lazify } from '../Common/Helper';

const CustomerRoutes = (
    <Route label="Customer" path="customer">
      <Route label="Account" path="account">
            <Route label="Forgot Password" path="forgotpassword" component={lazify(ForgotPasswordPage)}/>
            <Redirect from="login" to="/account/login" />
            <Redirect from="register" to="/account/register" />
        </Route>
    </Route>
);

export default CustomerRoutes;



// WEBPACK FOOTER //
// ./src/Routes/Customer.js